import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo-footer.png'
import _imports_1 from '../assets/images/QRcode.png'
import _imports_2 from '../assets/images/arro.png'


const _withScopeId = n => (_pushScopeId("data-v-56da07f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "list-con" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "解决方案", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "link" }, "刷脸&刷掌支付", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "link" }, "机器人3D视觉", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "link" }, "门锁门禁", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "link" }, "3D体积视频", -1))
const _hoisted_11 = { class: "list-con" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "产品中心", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "link" }, "3D结构光模组", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "link" }, "dToF激光雷达", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "link" }, "激光投射器", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "link" }, "光学设计软件", -1))
const _hoisted_17 = { class: "list-con" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "关于我们", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "link" }, "公司介绍", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "link" }, "新闻中心", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "link" }, "加入我们", -1))
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"list-con\" data-v-56da07f0><p class=\"title\" data-v-56da07f0>联系我们</p><p class=\"link\" data-v-56da07f0>商业合作：sales@angstrong.com</p><p class=\"link\" data-v-56da07f0>企业总机：0755-86568667</p><p class=\"link\" data-v-56da07f0>销售热线：0755-86968872</p></div>", 1)
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "code-box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "QRcode",
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "官方微信公众号")
], -1))
const _hoisted_24 = {
  key: 1,
  class: "company"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "粤ICP备18102273号", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502007077",
  target: "_blank"
}, "粤公安网备44030502007077", -1))
const _hoisted_27 = {
  key: 2,
  class: "menuCon"
}
const _hoisted_28 = { class: "logoCon" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "解决方案", -1))
const _hoisted_31 = {
  key: 0,
  class: "childrenCon"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "childrenList" }, "刷脸&刷掌支付", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "childrenList" }, "机器人3D视觉", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "childrenList" }, "门锁门禁", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "childrenList" }, "3D体积视频", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产品中心", -1))
const _hoisted_37 = {
  key: 1,
  class: "childrenCon"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "childrenList" }, "3D结构光模组", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "childrenList" }, "dToF激光雷达", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "childrenList" }, "激光投射器", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "childrenList" }, "光学设计软件", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "关于我们", -1))
const _hoisted_43 = {
  key: 2,
  class: "childrenCon"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "childrenList" }, "公司介绍", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "childrenList" }, "新闻中心", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "childrenList" }, "加入我们", -1))
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<div class=\"menuList menuSpecial\" data-v-56da07f0><span data-v-56da07f0>联系我们</span></div><div class=\"contectCon\" data-v-56da07f0><div class=\"leftCon\" data-v-56da07f0><p data-v-56da07f0>商业合作：sales@angstrong.com</p><p data-v-56da07f0>企业总机：0755-86568667</p><p data-v-56da07f0>销售热线：0755-86968872</p></div><div class=\"rightCon\" data-v-56da07f0><img src=\"" + _imports_1 + "\" alt=\"\" data-v-56da07f0><p data-v-56da07f0>官方微信公众号</p></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.windowWidth >= 800)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              to: { name: 'home' },
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSubmit('FooterBar-logo')))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_router_link, {
                  to: { name: 'PaymentPage' },
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSubmit('FooterBar-PaymentPage')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'RobotPage' },
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSubmit('FooterBar-RobotPage')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'LockPage' },
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSubmit('FooterBar-LockPage')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'MeasurePage' },
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSubmit('FooterBar-MeasurePage')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_router_link, {
                  to: { name: 'NuwaXB40' },
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSubmit('FooterBar-NuwaXB40')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'PurpleLi20' },
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSubmit('FooterBar-PurpleLi20')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'AuroraR1200' },
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleSubmit('FooterBar-AuroraR1200')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'DOEMaster' },
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSubmit('FooterBar-DOEMaster')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_router_link, {
                  to: { name: 'IntroducePage' },
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleSubmit('FooterBar-IntroducePage')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'NewsPage' },
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSubmit('FooterBar-NewsPage')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'JoinPage' },
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleSubmit('FooterBar-JoinPage')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                })
              ]),
              _hoisted_22
            ]),
            _hoisted_23
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.windowWidth >= 800)
      ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
          _createTextVNode(" 2018 © 深圳市安思疆科技有限公司 "),
          _hoisted_25,
          _createTextVNode(),
          _hoisted_26
        ]))
      : _createCommentVNode("", true),
    (_ctx.windowWidth < 800)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_router_link, {
              to: { name: 'home' },
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleSubmit('FooterBar-logo')))
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            class: "menuList",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.menuTag != 1 ? (_ctx.menuTag = 1) : (_ctx.menuTag = 0)))
          }, [
            _hoisted_30,
            _createElementVNode("img", {
              class: _normalizeClass(_ctx.menuTag == 1 ? 'menuActive' : ''),
              src: _imports_2,
              alt: ""
            }, null, 2)
          ]),
          (_ctx.menuTag == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createVNode(_component_router_link, {
                  to: { name: 'PaymentPage' },
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleSubmit('TopBar-PaymentPage')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_32
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'RobotPage' },
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleSubmit('TopBar-RobotPage')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_33
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'LockPage' },
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleSubmit('TopBar-LockPage')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_34
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'MeasurePage' },
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleSubmit('TopBar-MeasurePage')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "menuList",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.menuTag != 2 ? (_ctx.menuTag = 2) : (_ctx.menuTag = 0)))
          }, [
            _hoisted_36,
            _createElementVNode("img", {
              class: _normalizeClass(_ctx.menuTag == 2 ? 'menuActive' : ''),
              src: _imports_2,
              alt: ""
            }, null, 2)
          ]),
          (_ctx.menuTag == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createVNode(_component_router_link, {
                  to: { name: 'NuwaXB40' },
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleSubmit('FooterBar-NuwaXB40')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_38
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'PurpleLi20' },
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleSubmit('FooterBar-PurpleLi20')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_39
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'AuroraR1200' },
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleSubmit('FooterBar-AuroraR1200')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_40
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'DOEMaster' },
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleSubmit('FooterBar-DOEMaster')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_41
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "menuList",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.menuTag != 3 ? (_ctx.menuTag = 3) : (_ctx.menuTag = 0)))
          }, [
            _hoisted_42,
            _createElementVNode("img", {
              class: _normalizeClass(_ctx.menuTag == 3 ? 'menuActive' : ''),
              src: _imports_2,
              alt: ""
            }, null, 2)
          ]),
          (_ctx.menuTag == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createVNode(_component_router_link, {
                  to: { name: 'IntroducePage' },
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleSubmit('TopBar-IntroducePage')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_44
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'NewsPage' },
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleSubmit('TopBar-NewsPage')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_45
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'JoinPage' },
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.handleSubmit('TopBar-JoinPage')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_46
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _hoisted_47
        ]))
      : _createCommentVNode("", true)
  ], 64))
}